export default __webpack_public_path__ + "static/media/cafe.755089c7.jpg";